import axios from 'axios'
import VueCookies from "vue-cookies";
import { getSessionExpiredRedirectBase } from '@/utils/contextRedirect'
// For common config

//const token = VueCookies.get('epos2_token');

axios.defaults.withCredentials = true;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.get["Content-Type"] = "application/json";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.patch["Content-Type"] = "application/json";
axios.defaults.headers.delete["Content-Type"] = "application/json";
/*
axios.defaults.headers.post["Authorization"] = token ? `Bearer ${token}` : '';
axios.defaults.headers.get["Authorization"] = token ? `Bearer ${token}` : '';
axios.defaults.headers.put["Authorization"] = token ? `Bearer ${token}` : '';
axios.defaults.headers.patch["Authorization"] = token ? `Bearer ${token}` : '';
axios.defaults.headers.delete["Authorization"] = token ? `Bearer ${token}` : '';
*/
const interceptorsResponse = (error) => {
    if (error.response.status === 401) {
        const userid = VueCookies.get('epos2_userid');
        const workstationid = VueCookies.get('epos2_workstationid');
        const {status, data} = eposAxios.post(
            '/index.php?page=ajax&function=processAuthToken&user_id='+userid+'&workstation='+workstationid
        );
        if (status === 200) {
            VueCookies.set('epos2_token',data.token);
        }
    } else if (error.response.status === 403) {
        window.location = getSessionExpiredRedirectBase()
    }
}

const eposAxios = axios.create();
eposAxios.defaults.baseURL = process.env.VUE_APP_EPOS_API_BASE;
// Add a request interceptor
eposAxios.interceptors.request.use(function (config) {
    const token = VueCookies.get('epos2_token');
    config.headers.Authorization =   token ? `Bearer ${token}` : '';

    return config;
});

eposAxios.interceptors.response.use(response =>response, error => {
    interceptorsResponse(error);
    return Promise.reject(error);
});

const epos2Axios = axios.create();
epos2Axios.defaults.baseURL = process.env.VUE_APP_EPOS2_API_BASE;
// Add a request interceptor
epos2Axios.interceptors.request.use(function (config) {
    const token = VueCookies.get('epos2_token');
    config.headers.Authorization =   token ? `Bearer ${token}` : '';

    return config;
});
epos2Axios.interceptors.response.use(response =>response, error => {
    interceptorsResponse(error);
    return Promise.reject(error);
});

const goAxios = axios.create();
goAxios.defaults.baseURL = process.env.VUE_APP_GO_API_BASE;
goAxios.interceptors.request.use(function (config) {
    const token = VueCookies.get('epos2_token');
    config.headers.Authorization =   token ? `Bearer ${token}` : '';

    return config;
});
goAxios.interceptors.response.use(response =>response, error => {
    interceptorsResponse(error);
    return Promise.reject(error);
});

/*
const eposAxios = axios.create({
    baseURL: process.env.VUE_APP_EPOS_API_BASE,
    withCredentials: true
});

// Add a request interceptor
eposAxios.interceptors.request.use(function (config) {
    //const token = localStorage.getItem("token");
    const token = VueCookies.get('epos2_token');
    config.headers.Authorization =   token ? `Bearer ${token}` : '';

    return config;
});
eposAxios.interceptors.response.use(response =>response, error => {
    if (error.response.status === 401) {
        const userid = VueCookies.get('epos2_userid');
        const workstationid = VueCookies.get('epos2_workstationid');
        const {status, data} = eposAxios.post(
            '/index.php?page=ajax&function=processAuthToken&user_id='+userid+'&workstation='+workstationid
        );
        if (status === 200) {
            //eposAxios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
            VueCookies.set('epos2_token',data.token);
        }
    } else if (error.response.status === 403) {
        window.location = process.env.VUE_APP_EPOS_API_BASE
    }

    return Promise.reject(error);
});

const epos2Axios = axios.create({
    baseURL: process.env.VUE_APP_EPOS2_API_BASE,
    withCredentials: true
});

// Add a request interceptor
epos2Axios.interceptors.request.use(function (config) {
    //const token = localStorage.getItem("token");
    const token = VueCookies.get('epos2_token');
    config.headers.Authorization =   token ? `Bearer ${token}` : '';

    return config;
});
epos2Axios.interceptors.response.use(response =>response, error => {
    if (error.response.status === 401) {
        const userid = VueCookies.get('epos2_userid');
        const workstationid = VueCookies.get('epos2_workstationid');
        const {status, data} = eposAxios.post(
            '/index.php?page=ajax&function=processAuthToken&user_id='+userid+'&workstation='+workstationid
        );
        if (status === 200) {
            //eposAxios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
            VueCookies.set('epos2_token',data.token);
        }
    } else if (error.response.status === 403) {
        window.location = process.env.VUE_APP_EPOS_API_BASE
    }

    return Promise.reject(error);
});
*/

export {
    eposAxios,
    epos2Axios,
    goAxios
};
